import axios from 'axios'
import store from '@/store' // Importar directamente el store
import router from '@/router' // Importar el router para verificar la ruta actual

const API_URL =
  process.env.VUE_APP_API_BASE_URL

const api = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Interceptor para adjuntar el token en cada solicitud
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar errores de respuesta globalmente
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        // Manejar 401: No autorizado (sesión expirada o token inválido)
        store.dispatch('auth/logout')
        
        // Solo redirigir si NO estamos ya en la página de login o páginas de auth
        const currentRoute = router.currentRoute.value
        const isAuthPage = currentRoute.path === '/login' || 
                          currentRoute.path === '/forgot-password' || 
                          currentRoute.path.startsWith('/reset-password')
        
        if (!isAuthPage) {
          window.location.href = '/login'
        }
      } else if (error.response.status === 500) {
        // Manejar 500: Error interno del servidor
        console.error('Error interno del servidor:', error.response.data)
        return {
          message: 'Error interno del servidor',
          code_number: 500
        }
        //window.location.href = '/error500'
      }
    } else if (error.message.includes('Network Error')) {
      // Manejar problemas de red, como errores de CORS o falta de conexión
      // Solo redirigir si NO estamos ya en páginas de auth
      const currentRoute = router.currentRoute.value
      const isAuthPage = currentRoute.path === '/login' || 
                        currentRoute.path === '/forgot-password' || 
                        currentRoute.path.startsWith('/reset-password')
      
      if (!isAuthPage) {
        window.location.href = '/login'
      }
    }

    return Promise.reject(error) // Rechazar el error para que pueda ser manejado por cada solicitud si es necesario
  }
)

export default api
